<button id="landing-table-buttons" class="btn btn-sm btn-outline-dark py-0 my-1 px-1 border-0" (click)="invoke(type, data)" >
  <i class={{icon}} aria-hidden="true"></i>
</button>